import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();
  console.error('-----error paege',error);

  return (
    <div id="error-page">
      <h2>wrong path...</h2>
      <p>an expected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}

export { ErrorPage };